module.exports = __webpack_public_path__ + "dgrid.2U48Hxak.png";